import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    uploadedCSVFiles: null,
    csvIsLoading: false,
    savingInProgress: false,
    newCross: {
      for_brand_name: null,
      for_part_number: null,
      part_number: null,
      brand_name: null,
      part_name: null,
      image: null,
      image_file_name: null,
    },
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    listuploadedCSV({ commit, state }) {
      //csv-uploaded-files
      return axios
        .get(this._vm.$apiURL + "/am/crosses/csv-uploaded-files")
        .then((data) => {
          if (data.data.files) {
            if (data.data.files.length) {
              state.uploadedCSVFiles = data.data.files;
            }
          }
        });
    },
    uploadCSVCrossess: async function ({ commit, state, dispatch }, payload) {
      state.csvIsLoading = true;
      let file = payload.file; //this.$refs.uploadCSVinput.files[0];
      if (file.type !== "text/csv") {
        state.csvIsLoading = false;
        this._vm.$error(error.message);
      } else {
        let formData = new FormData();
        formData.append("file", file);

        return await axios
          .post(this._vm.$apiURL + "/am/crosses/csv-upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((data) => {
            //this.listuploadedCSV();
            dispatch("listuploadedCSV");
            state.csvIsLoading = false;
          })
          .catch((error) => {
            state.csvIsLoading = false;
            dispatch("common/showError", { error: error }, { root: true });
          });
      }
    },
    restoreSettings: async function ({ commit, state, dispatch }) {
      return await this._vm
        .$confirm({
          title: this._vm.i18n.t("common.confirm"),
          text: this._vm.i18n.t("viewAMCrosses.confirm_delete_all_crosses_settings"),
          cancelText: this._vm.i18n.t("common.no"),
          acceptText: this._vm.i18n.t("common.yes"),
        })
        .then(async (y) => {
          return await axios
            .post(this._vm.$apiURL + "/am/crosses/clear")
            .then(async (response) => {
              if (response.data.status === "success") {
                state.finded = {
                  aliases: "",
                  brand: null,
                  deleted: [],
                };
                state.newBrandOrAlias = {
                  type: "",
                  brand: "",
                  alias: "",
                };
                return response.data.status;
              }
            })
            .catch((error) => {
              dispatch("common/showError", { error: error }, { root: true });
            });
        })
        .catch((n) => {});
    },
    addNew: async function ({ commit, state, dispatch }) {
      updateField(state, { path: "savingInProgress", value: true });
      let formData = new FormData();

      for (let i in state.newCross) {
        if(state.newCross[i]!==null) {
          formData.append(i, state.newCross[i]);
        }
      }
      return await axios
        .post(this._vm.$apiURL + "/am/crosses/add", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status === "success") {
            for (let i in state.newCross) {
              state.newCross[i] = null;
            }
            return response.data.status;
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
  },
};
